import { ErrorHandler, Injectable } from "@angular/core";
import { LoggingService } from "./logging.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private loggingService: LoggingService) {
        super();
    }

    handleError(error: any) {
        // Attempt to capture additional context from common API error shapes
        // log additioanl details if available; production responses won't have stacktraces.
        const src: any = error && error.error ? error.error : error;
        const requestId = src?.RequestId || src?.requestId;
        const correlationId = src?.CorrelationId || src?.correlationId;
        const exceptionMessage = src?.ExceptionMessage || src?.exceptionMessage;
        const stackTrace = src?.StackTrace || src?.stackTrace;

        const meta: { [key: string]: any } = {
            RequestId: requestId,
            CorrelationId: correlationId,
            ExceptionMessage: exceptionMessage,
            StackTrace: stackTrace,
            RawError: error
        };

        const errors = Array.isArray(src?.Errors) ? src.Errors : null;
        if (errors && errors.length > 0) {
            errors.forEach((e: any) => {
                const message = e?.Message ? e.Message : e;
                this.loggingService.logException(new Error(message), undefined, {
                    ...meta,
                    Error: e
                });
            });
            return;
        }

        if (error instanceof Error) {
            this.loggingService.logException(error, undefined, meta);
        } else {
            this.loggingService.logException(new Error('Unhandled error'), undefined, meta);
        }
    }
}